let resource = new MeetingTypesResource()

const state = {
  meeting_type_list: [],
  meeting_type_loading: false,
  meeting_type_fetched: false
}

const getters = {
  meetingTypesCount: function (state) {
    return state.meeting_type_list.length
  },
  meetingTypesList: function (state) {
    return state.meeting_type_list
  },
  meetingTypeLoading: function (state) {
    return state.meeting_type_loading
  },
  meetingTypeFetched: function (state) {
    return state.meeting_type_fetched
  }
}

const mutations = {
  loadMeetingTypes: function (state, meeting_types) {
    if(meeting_types){
      state.meeting_type_list = meeting_types
    } else {
      state.meeting_type_list = []
    }
  },
  addMeetingType: function (state, meeting_type) {
    state.meeting_type_list.unshift(meeting_type)
  },
  removeMeetingType: function (state, meeting_type) {
    state.meeting_type_list.remove(meeting_type.id)
  },
  replaceMeetingType: function (state, meeting_type) {
    state.meeting_type_list.replaceById(meeting_type)
  },
  resetMeetingTypes: function (state) {
    state.meeting_type_list = []
  },
  setMettingTypeLoading: function (state, loading) {
    state.meeting_type_loading = loading
  },
  setMeetingTypeFetched: function (state, fetched) {
    state.meeting_type_fetched = fetched
  }
}

const actions = {
  fetchMeetingTypes (context, payload){
    context.commit('setMettingTypeLoading', true)

    if(!context.getters.meetingTypeFetched){
      resource.index(response => {
        context.commit('setMettingTypeLoading', false)
        context.commit('setMeetingTypeFetched', true)
        context.commit('loadMeetingTypes', response.meeting_types)
      },

      function(error) {
        context.commit('setMettingTypeLoading', false)
        if(payload && payload.errorCallback) {
          payload.errorCallback(error)
        }
      })
    }
    context.commit('setMettingTypeLoading', false)
  },

  createMeetingType (context, payload) {
    context.commit('setMettingTypeLoading', true)

    resource.create(response => {
      context.commit('setMettingTypeLoading', false)
      context.commit('addMeetingType', response.data.meeting_type)

      alertify.success('Tipo de reunião salvo com sucesso.')
    },

    function(error) {
      context.commit('setMettingTypeLoading', false)
      alertify.error('Ocorreu um erro ao salvar o tipo de reunião.')
    }, payload)
  },

  removeMeetingType (context, payload) {
    context.commit('setMettingTypeLoading', true)

    resource.destroy(response => {
      context.commit('setMettingTypeLoading', false)
      context.commit('removeMeetingType', payload)

      alertify.success('Tipo de reunião excluído com sucesso.')
    },

    function(error) {
      context.commit('setMettingTypeLoading', false)
      if(!error.body || !error.body.base) {
        alertify.error('Ocorreu um erro ao excluir o tipo de reunião.')
        return
      }

      alertify.error(error.body.base[0])
    }, payload)
  },

  updateMeetingType (context, payload) {
    context.commit('setMettingTypeLoading', true)

    resource.update(response => {
      context.commit('setMettingTypeLoading', false)
      context.commit('replaceMeetingType', response.meeting_type)

      alertify.success('Tipo de reunião salvo com sucesso.')
    },

    function(error) {
      context.commit('setMettingTypeLoading', false)
      alertify.error('Ocorreu um erro ao salvar o tipo de reunião.')
    }, payload)
  },

  resetMeetingTypes (context) {
    context.commit('resetMeetingTypes', [])
  },
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/meeting_type.js